import store from "@/store";
import { getActivePinia } from "pinia";
import { usePrivilegesStore } from "@/stores/privileges";
import { useOrganizationStore } from "@/stores/organizationStore";
import { useSessionSelfStore } from "@/stores/sessionSelf";

/**
 * Load the permissions and the signed-in person's profile once there is a
 * session (after sign-in, a reload, or entering/exiting a patient chart).
 *
 * Both are `GET /me` (the privileges store and sessionSelf are lenses over
 * `useSessionStore()`), so this is one request however many ask. Main gated
 * the profile on `is2faVerified` because keyon's GetSelfProfile was
 * MFA-enforced. On the port GET /me is the shell's call and answers any
 * signed-in token, so a signed-in session is enough here (MX-13): what these
 * two need from it, the ids, names and permissions, is never withheld. A token
 * can lack a second factor (pacmny-auth asks for one only when the person's
 * MFA is on), so what main kept behind it stays behind it on the API: GET /me
 * and GET /me/bootstrap (getAllData) leave out the self-profile fields without
 * a recent second factor, and My Profile reads GET /me/profile and saves
 * through PATCH /me, both behind `mfa`.
 */
export function syncPrivilegesAfterSessionChange() {
  const pinia = getActivePinia();
  if (!pinia || !store.getters["login/isLoggedIn"]) {
    return;
  }
  const phr = store.getters["login/getAllData"];
  if (!phr) {
    return;
  }
  usePrivilegesStore(pinia).ensureLoaded();
  useSessionSelfStore(pinia).fetchForCurrentSession();
}

export function clearPrivilegesStore() {
  const pinia = getActivePinia();
  if (!pinia) {
    return;
  }
  usePrivilegesStore(pinia).clear();
  useSessionSelfStore(pinia).clear();
}

/** Clear cached accounts.organization on logout. */
export function clearOrganizationStore() {
  const pinia = getActivePinia();
  if (!pinia) {
    return;
  }
  useOrganizationStore(pinia).clear();
}
